export default __webpack_public_path__ + "static/media/PPI-driveway-019.ced7b691.jpg";